import Head from 'next/head';
import type { ComponentPropsWithRef } from 'react';
import { forwardRef } from 'react';

type HtmlHeadProps = ComponentPropsWithRef<'head'> & {
  title?: string;
  description?: string;
};

export const HtmlHead = forwardRef<HTMLHeadElement, HtmlHeadProps>(
  (props, ref) => {
    const { children, title, description, ...htmlProps } = props;

    return (
      <Head ref={ref} {...htmlProps}>
        <title>
          {title && title.length > 0 && `${title} | `}SIGNATE Cloud 組織管理画面
        </title>
        {description && <meta name="description" content={description} />}
        {children}
      </Head>
    );
  }
);
HtmlHead.displayName = '@signate-cloud/admin-app/HtmlHead';
